import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { useParksViewContext } from "provider/ParkViewProvider";

const WriteReviewModal = () => {
  const { parkViewReviewModalToggle, parksViewDispatch } = useParksViewContext();
  const [rating, setRating] = useState(0);
  const [review, setReview] = useState("");

  const handleClose = () => {
    parksViewDispatch({ type: "SET_PARK_VIEW_REVIEW_MODAL_TOGGLE", payload: false });
    setRating(0);
    setReview("");
  }
  const handleStarClick = (value) => {
    setRating(value);
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    // console.log("Rating:", rating);
    // console.log("Review:", review);
    // Call your API here
    handleClose();
  };
  
  return (
    <Modal show={parkViewReviewModalToggle} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <h1 className="modal-title fs-5">Suggest Correction</h1>
      </Modal.Header>
      <Modal.Body>
        <div id="modalContent">
          <div className="modal-body modal_form">
            <Form id="review-form" onSubmit={handleSubmit}>
              <div className="row">
                <div className="mb-3 field-safariparkreviewform-safari_park_id required">
                  <input type="hidden" className="form-control" />

                  <div className="invalid-feedback"></div>
                </div>{" "}
                <div className="col-12 my-4">
                  <div className="stars d-flex gap-4 justify-content-center">
                    <div className="mb-3 field-safariparkreviewform-rating required">
                      <label
                        className="form-label"
                        for="safariparkreviewform-rating"
                      ></label>
                      <input
                        type="hidden"
                        id="safariparkreviewform-rating"
                        className="form-control"
                      />

                      <div className="invalid-feedback"></div>
                    </div>{" "}
                    <div className="stars d-flex gap-4 justify-content-center">
                      <i
                        className="fa-regular fa-star star_icon_1 fa-solid"
                        value="1"
                        style={{ color: "rgb(253, 191, 43)" }}
                      ></i>
                      <i
                        className="fa-regular fa-star star_icon_2 fa-solid"
                        value="2"
                        style={{ color: "black" }}
                      ></i>
                      <i
                        className="fa-regular fa-star star_icon_3 fa-solid"
                        value="3"
                        style={{ color: "black" }}
                      ></i>
                      <i
                        className="fa-regular fa-star star_icon_4 fa-solid"
                        value="4"
                        style={{ color: "black" }}
                      ></i>
                      <i
                        className="fa-regular fa-star star_icon_5 fa-solid"
                        value="5"
                        style={{ color: "black" }}
                      ></i>
                    </div>
                  </div>
                </div>
                <div className="col-lg-12 mb-2 ">
                  <div className="textarea">
                    <div className="mb-3 field-safariparkreviewform-review required">
                      <textarea
                        id="safariparkreviewform-review"
                        className="form-control"
                        placeholder="Write your review"
                        aria-required="true"
                      ></textarea>

                      <div className="invalid-feedback"></div>
                    </div>{" "}
                  </div>
                </div>
                <div className="col-12 py-2">
                  <div className="submir_review">
                    <button type="submit" name="submit-button">
                      Submit Review
                    </button>{" "}
                  </div>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default WriteReviewModal;
